// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";

type Props = $Exact<{
  onDismissHandler: () => *,
  onSubmit: () => void,
  documentName: string,
  employeeName: string,
  ...PropsFromLocalize,
}>;

export const RemoveDocumentModal = (props: Props) => (
  <Modal className="modal-small">
    <ModalHeader className="d-flex justify-content-between" toggle={props.onDismissHandler}>
      {props.t("REMOVE_DOCUMENT_MODAL_TITLE")}
    </ModalHeader>
    <ModalBody className="d-flex justify-content-center align-items-center">
      <p>
        {props.t("REMOVE_DOCUMENT_CONFIRMATION", {
          documentName: <strong>{props.documentName}</strong>,
          employeeName: <strong>{props.employeeName}</strong>,
        })}
      </p>
    </ModalBody>
    <ModalFooter className="d-flex justify-content-end">
      <Button color="secondary" onClick={props.onDismissHandler}>
        {props.t("CANCEL")}
      </Button>
      <Button materialIcon="delete_forever" onClick={props.onSubmit}>
        {props.t("DELETE")}
      </Button>
    </ModalFooter>
  </Modal>
);

export default localize()(RemoveDocumentModal);
